export const serverErrors = {
    404: "Страница удалена или не существует",
    422: "Ошибка",
    403: "У вас нет доступа",
    401: "Войдите или зарегистрируйтесь",
    556: "В данный момент на сайте проводится обновление, Пожалуйста подождите пару минут, и попробуйте снова.",
    557: "Обновите страницу и попробуйте снова.",
    558: "Доступ будет возобновлен после оплаты используемых услуг.",
    500: "Ошибка на сервере, обратитесь в службу техподдержки",
    503: "Кажется вас стало слишком много, скоро мы вернемся",
};